import { Text } from "components/general/Text";
import { NAV_LINKS } from "../../../config/consts";
import { GlobalStore } from "../../../store/global/GlobalStore";
import styled from "@emotion/styled";

export const NavLinks = () => {
  const theme = GlobalStore.useState(s => s.theme);

  return (
    <div style={{ display: "flex", gap: 8 }}>
      <DesktopNavLink href={NAV_LINKS.FAQ} target="_blank" rel="noreferrer" theme={theme}>
        <Text textStyle="Button" size="Medium">
          Help centre
        </Text>
      </DesktopNavLink>
    </div>
  );
};

// Sub-components

export const DesktopNavLink = styled.a(({ theme }) => ({
  padding: "12px 14px",
  textAlign: "center",
  color: theme.font.primary.default,
  cursor: "pointer",

  "&:hover": {
    color: theme.font.primary.hover,
  },
}));
